import { Card, Flex, Typography } from "antd";
import Chart from "react-apexcharts";
import React from "react";

export default function InsuranceEngagement() {
  const series = [24, 32, 34]; // Recurring: 24%, Others: 76%

  const options = {
    chart: {
      type: "donut",
      height: 250,
    },
    labels: ["Recurring", "Others"],
    colors: ["#E0DDF7", "#AD9EE7", "#6B43B5"], // Purple for Recurring, light gray for Others
    legend: { show: false },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        donut: {
          size: "85%",
          labels: {
            show: true,
            // name: { show: false },
            value: { show: true, color: "#979797", fontSize: "16px", offsetY: -5 },
            total: {
              show: true,
              showAlways: true,
              label: "Insurance",
              color: "#979797",
              fontSize: "16px",
              fontWeight: 400,
              formatter: () => "Engagement",
            },
          },
        },
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return val + "%";
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
      active: {
        filter: {
          type: "none",
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 240,
          },
        },
      },
    ],
  };

  return (
    <Card style={{ minWidth: 350 }}>
      <Flex vertical>
        <Typography.Title level={4}>Insurance Engagement</Typography.Title>
        <Chart options={options} series={series} type="donut" height={250} />
      </Flex>
    </Card>
  );
}
